import React, { useState, useCallback, useEffect, useRef } from "react";
import _ from "lodash";
import {
  _getBaseUrl,
  _getTileShape,
} from "../utils/helper";

const InspiratiepuntenAdminDashboardListView = (props) => {
  const posts = props.posts;

  return (
    <div>
      <div className="list-head-row flex flex-nowrap justify-between items-end">
        <div className="list-data"></div>
        <div className="list-data"></div>
        <div className="list-head">Titel</div>
        <div className="list-head">Gebruiker</div>
        <div className="list-head">Type</div>
        <div className="list-head">Thema</div>
        <div className="list-head">Status</div>
        <div className="list-head"></div>
        <div className="list-head"></div>
      </div>
      <div className="relative min-h-[150px]">
        {(posts !== null && posts.length > 0) && posts?.map((post, index) => (
          <div className="list-data-row flex flex-nowrap justify-between items-center">
            <div className="list-data flex justify-center">
              <input
                type="checkbox"
                value={post.nid}
                checked={props.selectedPost.includes(post.nid)}
                onChange={(e) => {
                  const checked = e.target.checked;

                  if (checked) {
                    props.setSelectedPost([
                      ...props.selectedPost,
                      post.nid,
                    ]);
                  } else {
                    props.setSelectedPost(
                      props.selectedPost.filter(
                        (nid) => nid !== post.nid
                      )
                    );
                  }
                }}
              />
            </div>
            <div className="list-data flex justify-center">
              <div className="w-[68px] aspect-square relative">
                <div className="absolute bottom-1 -right-1 z-0">
                  {_getTileShape(post.thumbnailShape, post.color)}
                </div>
                <img
                  src={post.imageUrl}
                  alt={post.imageAlt}
                  className={`list-thumbnail w-full h-full object-cover relative z-10 clip-path-${post.thumbnailShape}`}
                />
              </div>
            </div>
            <div className="list-data">{post.title}</div>
            <div className="list-data">{post.username}</div>
            <div className="list-data">{post.type}</div>
            <div className="list-data">{post.transitieagendaLabel}</div>
            <div className="list-data">{post.postStatus.label}</div>
            <div className="list-data">
              <a
                href={`/praktijkervaring/edit/${post.nid}`}
                className=" hover:opacity-60"
              >
                <img
                  src={_getBaseUrl(
                    "src/assets/inspiratiepunten/icon-edit.svg",
                    true
                  )}
                  alt="Icon"
                />
              </a>
            </div>
            <div className="list-data">
              <a
                href={post.permalink}
                className="block mx-auto hover:opacity-60"
              >
                <img
                  src={_getBaseUrl(
                    "src/assets/inspiratiepunten/icon-view-alt.svg",
                    true
                  )}
                  alt="Icon"
                />
              </a>
            </div>
          </div>
        ))}

        {!props.isFirstLoadPosts && (posts.length === 0 || posts === null) && (
          <div className="min-h-[150px] h-full flex items-center justify-center">
            <p className="text-lg">Geen resultaten</p>
          </div>
        )}

        {props.isLoadingPosts && (
          <div className="absolute top-0 left-0 w-full h-full z-50 bg-white bg-opacity-75 flex items-center justify-center pointer-events-none">
            <img
              src={_getBaseUrl("src/assets/loading.gif", true)}
              alt="Loading"
              className="scale-50"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default InspiratiepuntenAdminDashboardListView;
